<div
    *ngIf="!userService.isOnlyTg"
    [ngClass]="{
        'max-h-[540px] overflow-y-auto':pageType === 'profile'
    }"
>
    <div class="flex justify-between items-center relative">
        <nz-select
            nzPlaceHolder="Select Chain"
            class="w-40 relative"
            [(ngModel)]="currentActiveChain"
            (ngModelChange)="refresh()"
            [nzCustomTemplate]="defaultTemplate"
            [nzBackdrop]="true"
        >
            <nz-option nzLabel="All" nzValue="all"> </nz-option>
            <nz-option *ngFor="let chain of chains" nzCustomContent [nzLabel]="chain" [nzValue]="chain">
                <img [src]="getChainInfo(chain)?.imgUrl" class="w-5 h-5 mr-1 inline-block align-middle rounded-full" alt="" />
                {{ getChainInfo(chain)?.name }}
            </nz-option>

            <ng-template #defaultTemplate let-selected>
                <ng-container *ngIf="selected.nzValue === 'all'"> All</ng-container>
                <ng-container *ngIf="selected.nzValue !== 'all'">
                    <img
                        [src]="getChainInfo(selected.nzValue)?.imgUrl"
                        class="w-5 h-5 mr-1 inline-block align-middle rounded-full"
                        style="vertical-align: -0.35em"
                        alt=""
                    />
                    {{ getChainInfo(selected.nzValue)?.name }}
                </ng-container>
            </ng-template>
        </nz-select>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 mt-5">
        <app-transaction-card-v2 *ngFor="let transaction of transactions" [transaction]="transaction"></app-transaction-card-v2>
    </div>

    <nz-skeleton *ngIf="!isLastPage" [nzActive]="true" appScrollObserver (scrolledIntoView)="fetchData()"></nz-skeleton>

    <div *ngIf="isLastPage && !transactions?.length" class="w-[160px] mx-auto text-center text-[#b5b5b5]">
        <img class="w-36 mx-auto" src="/assets/imgs/no-data/no-data.png" alt="No Txn Data" />
        <div>No Transactions</div>
    </div>
</div>

<div *ngIf="userService.isOnlyTg">
    <!-- TG Connect Wallet -->
    <div class="text-center pb-10 text-[#b5b5b5]">
        <img class="mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>Please connect your wallet first.</div>
        <button nz-button nzType="primary" class="mt-4 !h-[34px] !w-[137px]" nzSize="small" (click)="commonService.showLogInModal('Connect New Wallet')">
            <span class="colorful-text">Connect Wallet</span>
        </button>
    </div>
</div>
